import { render } from "./MediaflowDock.vue?vue&type=template&id=c9edf3f0"
import script from "./MediaflowDock.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowDock.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowDock.vue?vue&type=style&index=0&id=c9edf3f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowDock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9edf3f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9edf3f0', __exports__)) {
    api.reload('c9edf3f0', __exports__)
  }
  
  module.hot.accept("./MediaflowDock.vue?vue&type=template&id=c9edf3f0", () => {
    api.rerender('c9edf3f0', render)
  })

}


export default __exports__